module.exports = __webpack_public_path__ + "static/img/empty_study.a712e1ad.png";